export default __webpack_public_path__ + "static/media/Ballroll_00098.01cd5184.png";